import {Outlet} from 'react-router-dom';
import {AppProvider} from '@/matic/providers/AppProvider';
import {QueryProvider} from '@/matic/features/_shared/components/providers/query-provider';
import {ToastProvider} from '@/matic/components/ui/toast';
import {AuthProvider} from 'react-oidc-context';
import {getOidcConfig} from '@/matic/lib/auth/oidc-config';

/**
 * Root layout for the entire application
 * Provides all global providers and renders child routes via <Outlet />
 *
 * Note: The persistent #app-loader overlay is dismissed by `<HideAppLoader />`
 * placed inside each route's `<Suspense>`, so it stays up smoothly until the
 * lazy page component is ready to paint. A 10s safety timeout in main.tsx
 * guarantees the overlay can't be permanently stuck.
 */
export function RootLayout() {
  const oidcConfig = getOidcConfig();

  return (
    <AuthProvider {...oidcConfig}>
      <AppProvider>
        <QueryProvider>
          <ToastProvider>
            <Outlet />
          </ToastProvider>
        </QueryProvider>
      </AppProvider>
    </AuthProvider>
  );
}
